import { WORKS_INFO_INSERT_SIGN } from "@/dictionary"

const insertSignOptions = Object.keys(WORKS_INFO_INSERT_SIGN).map(key => WORKS_INFO_INSERT_SIGN[key])

const resolveCertContent = ({ content = "", activityName = "", certDetail = {} } = {}) => {
  // 瞎几把写在这里
  const keyMap = {
    "[#USER_NAME#]": "userName",
    "[#WORKS_NAME#]": "worksName",
    "[#ADVISOR#]": "advisorName"
  }
  let result = content
  insertSignOptions.forEach(item => {
    const regStr = item.value.replace(/(\[|\])/g, "\\$1")
    const reg = new RegExp(`${regStr}`, "g")
    activityName = activityName || "活动名称"
    const replaceVal = item.value.indexOf("ACTIVITY_NAME") > -1 ? activityName : certDetail[keyMap[item.value]] || item.label
    result = result.replace(reg, `${replaceVal}`)
  })
  return result
}

export default resolveCertContent
